import React, { useState } from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';
import { WorkQuestionCard } from './WorkActionCards';

export default function WorkQuestionHistoryRow({ taskId, question, onAnswered, onViewInteraction, readOnly = false }) {
  const [expanded, setExpanded] = useState(false);
  const label = question.question || question.questions?.[0]?.question || 'Earlier question';
  return <View style={{ paddingVertical: 10, gap: 8 }}>
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12 }}>
      <Text size="s" color="secondary" numberOfLines={2} style={{ flex: 1 }}>{label}</Text>
      {!readOnly && <Button text={expanded ? 'Answer later' : 'Answer now'} size="small" variant="secondary"
        accessibilityLabel={`${expanded ? 'Close' : 'Answer'} earlier question: ${label}`}
        onPress={() => { onViewInteraction?.(); setExpanded(value => !value); }} />}
    </View>
    {expanded && !readOnly && <WorkQuestionCard taskId={taskId} question={{ ...question, historical: true, orphaned: false }}
      onAnswered={async (text, extra) => { await onAnswered?.(text, extra); setExpanded(false); }} />}
  </View>;
}
